module.exports = __webpack_public_path__ + "static/media/main-slide-1.c6b52653.jpg";